var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "#45C4B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1037 60.9L37.3188 57.6807C36.9106 56.3521 36.6554 54.9213 36.6554 53.465H16.242V17.2351H51.9654V37.905C53.7516 37.905 55.4612 38.2372 57.0688 38.7993V9.8L53.2413 13.6325L49.4138 9.8L45.5863 13.6325L41.7587 9.8L37.9312 13.6325L34.1037 9.8L30.2762 13.6325L26.4487 9.8L22.6212 13.6325L18.7936 9.8L14.9661 13.6325L11.1386 9.8V60.9L14.9661 57.0675L18.7936 60.9L22.6212 57.0675L26.4487 60.9L30.2762 57.0675L34.1037 60.9ZM18.7936 48.125V43.015H40.585C39.2071 44.4969 38.2119 46.2088 37.5485 48.125H18.7936ZM49.4138 37.905H18.7936V32.795H49.4138V37.905ZM49.4138 27.685H18.7936V22.575H49.4138V27.685ZM47.0985 49.4064V59.6264H51.6348V49.4064L55.604 53.3809L58.3485 50.6328L49.3666 41.6392L40.3847 50.6328L43.1292 53.3809L47.0985 49.4064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceUpload);
export default __webpack_public_path__ + "static/media/invoiceUpload.92770da5d5aa922d05804cc038cded82.svg";
export { ForwardRef as ReactComponent };